<template>
  <b-modal v-model="visible" title="Adicionar novo step" size="md" centered hide-footer>
    <div class="add-node-search mb-3">
      <input type="text" class="form-control" v-model="search" placeholder="Buscar step..." />
    </div>
    <div class="add-node-list">
      <div v-for="category in filteredCategories" :key="category.id" class="mb-3">
        <h6 class="text-muted font-size-12 text-uppercase mb-2">
          <i :class="category.icon" class="mr-1"></i> {{ category.label }}
        </h6>
        <div
          v-for="node in category.nodes"
          :key="node.kind"
          class="add-node-item"
          @click="selectNode(node)"
        >
          <div class="item-icon" :style="{ background: node.color + '1a', color: node.color }">
            <i :class="node.icon"></i>
          </div>
          <div class="item-info">
            <span class="item-label">{{ node.label }}</span>
            <span class="item-desc">{{ node.description }}</span>
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { nodeCategories } from '../../nodeLibrary'

export default {
  props: {
    value: { type: Boolean, default: false },
    showTriggers: { type: Boolean, default: false }
  },
  data () {
    return { search: '' }
  },
  computed: {
    visible: {
      get () { return this.value },
      set (val) { this.$emit('input', val) }
    },
    filteredCategories () {
      const cats = this.showTriggers ? nodeCategories : nodeCategories.filter(c => c.id !== 'triggers')
      if (!this.search) return cats
      const q = this.search.toLowerCase()
      return cats.map(cat => ({
        ...cat,
        nodes: cat.nodes.filter(n => n.label.toLowerCase().includes(q) || n.description.toLowerCase().includes(q))
      })).filter(cat => cat.nodes.length > 0)
    }
  },
  methods: {
    selectNode (node) {
      this.$emit('add-node', { ...node })
    }
  },
  watch: {
    visible (val) {
      if (!val) this.search = ''
    }
  }
}
</script>

<style scoped>
.add-node-list { max-height: 400px; overflow-y: auto; }
.add-node-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 10px;
  border-radius: 6px;
  cursor: pointer;
  transition: background 0.15s;
}
.add-node-item:hover { background: #f3f4f6; }
.item-icon {
  width: 34px;
  height: 34px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  flex-shrink: 0;
}
.item-info { flex: 1; display: flex; flex-direction: column; }
.item-label { font-size: 13px; font-weight: 500; color: #495057; }
.item-desc { font-size: 11px; color: #adb5bd; }
</style>
